<template>
    <v-container>
        <h2 class="sub-titulo text-center">Cadastro cliente</h2>
        <v-row class="justify-center">
            <v-col cols="12" sm="8" md="4">
                <v-col class="tipo-pessoa-label text-center">Selecione o tipo de pessoa</v-col>
                <SlideButton id="tipoPessoa" :values="['Pessoa física', 'Pessoa jurídica']" v-model="is_fisica" />
            </v-col>
        </v-row>
        <v-stepper v-model="step">
            <v-stepper-content step="1">
                <Fisica v-model="pedido" :ref="TipoPessoa.Fisica" @nextPage="realizarVenda" @prevPage="$emit('prevPage')" @loadCliente="parseCliente" />
            </v-stepper-content>
            <v-stepper-content step="2">
                <Juridica v-model="pedido" :ref="TipoPessoa.Juridica" @nextPage="realizarVenda" @prevPage="$emit('prevPage')" @loadCliente="parseCliente" />
            </v-stepper-content>
        </v-stepper>
    </v-container>
</template>

<script>
  import Fisica from './Fisica'
  import Juridica from './Juridica'

  import { notification, getComissionadoNormalized } from '@/plugins/helpers'
  import { TipoPessoa } from '@/plugins/constants'
  import { cloneDeep, isNil, set } from 'lodash'
  import { deletarCamposParaSalvarCliente } from '../../../plugins/vendasHelper'
  import { AlertTypes } from '../../../plugins/alerts_types'

  const clienteDefault = () => ({
    bloqueado: false,
    pessoa: TipoPessoa.Fisica,
    politicamente_exposto: null,
    id_parentesco: null,
    id_cargo_politico: null,
    genero: null,
    data_nascimento: '',
    data_nascimento_socio: '',
    nacionalidade: '',
    nome_completo: '',
    cpf: '',
    cpf_socio: '',
    renda: null,
    telefone_residencial: '',
    telefone_celular: '',
    email: '',
    rg: '',
    orgao_expeditor: '',
    data_emissao: '',
    nome_pai: '',
    nome_mae: '',
    id_profissao: null,
    patrimonio: null,
    id_cidade_nascimento: null,
    id_estado_civil: null,
    nome_conjuge: '',
    cpf_conjuge: '',
    cnpj: '',
    razao_social: '',
    nome_fantasia: '',
    data_fundacao: '',
    id_atividade: null,
    id_tipo_empresa: null,
    inscricao_estadual: '',
    isento_inscricao: false,
    registro_dados_constitutivos: '',
    faturamento_medio: null,
    telefone_comercial: '',
    percentual_participacao: ''
  })

  export default {
    name: 'Pessoa',
    components: { Juridica, Fisica },
    props: {
      value: { type: Object }
    },
    data: () => ({
      TipoPessoa,
      pedido: {
        cliente: {
          pessoa: TipoPessoa.Fisica
        },
        fluxo_venda_atual: 'iniciar_cadastro',
        multiplicador_cota_habilitado_na_venda: false,
        flavor_atual: null,
        identificador_representante_tribanco: null
      },
      clienteOriginal: null
    }),
    computed: {
      is_fisica: {
        get () {
          return this.pedido.cliente.pessoa === TipoPessoa.Fisica
        },
        set (val) {
          val = val ? TipoPessoa.Fisica : TipoPessoa.Juridica
          this.pedido.cliente = clienteDefault()

          this.$refs[val].desbloquearCampos()
          if (val === TipoPessoa.Juridica) {
            this.$refs[val].desbloquearCamposSocio()
            this.$refs[val].limparDadosBeneficiario()
            this.$refs[val].resetUltimoDocumentoPj()
          }
          if (val === TipoPessoa.Fisica) {
            this.$refs[val].limparEDesbloquearCidadeNascimento()
            this.$refs[val].resetUltimoDocumento()
          }
          this.$refs[val].resetForm()
          this.pedido.cliente.pessoa = val
        }
      },
      step () { return this.is_fisica ? 1 : 2 }
    },
    mounted () {
      this.pedido.flavor_atual = this.$session.get('flavor') || null
      this.pedido.multiplicador_cota_habilitado_na_venda = this.$session.get('permite_multiplicar_cota')
      this.pedido.cliente = { ...this.pedido.cliente, ...this.value.cliente }
      this.pedido = { ...this.value, ...this.pedido }
      this.clienteOriginal = cloneDeep(this.pedido.cliente)
    },
    methods: {
      async realizarVenda () {
        const filial = this.$session.get('filial')
        const pedido = cloneDeep(this.pedido)
        if (!pedido.id_regiao_fiscal) pedido.id_regiao_fiscal = 1
        if (!pedido.id_filial) pedido.id_filial = filial.ID_Filial_Venda
        if (!pedido.nome_filial) pedido.nome_filial = filial.NM_Filial_Venda
        if (!pedido.cd_filial) pedido.cd_filial = filial.CD_Filial_Venda
        pedido.id_usuario = this.$session.get('id_usuario')
        const comissionadoData = getComissionadoNormalized(this.$session.get('id_comissionado_venda'), this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
        pedido.id_comissionado = comissionadoData.id_comissionado
        pedido.cd_comissionado = comissionadoData.cd_comissionado
        pedido.nm_comissionado = comissionadoData.nm_comissionado
        pedido.id_ponto_venda = this.$session.get('id_ponto_venda')
        pedido.backoffice = this.$session.get('vendas_backoffice')
        pedido.origem_acesso = this.$session.get('origem_acesso')

        pedido.nm_ponto_venda = this.$session.get('nm_ponto_venda')
        pedido.cd_ponto_venda = this.$session.get('cd_ponto_venda')

        pedido.flavor_atual = this.$session.get('flavor')
        pedido.identificador_representante_tribanco = this.$session.get('identificador_representante_tribanco')
        const ambientes = this.$session.get('ambiente')
        if (ambientes && ambientes.unidade_condicoes_venda) {
          pedido.unidade_condicoes_venda = ambientes.unidade_condicoes_venda
        }

        let atualizarInstancia = false

        if (this.clienteOriginal && (pedido.cliente.email !== this.clienteOriginal.email || pedido.cliente.telefone_celular !== this.clienteOriginal.telefone_celular || pedido.cliente.telefone_comercial !== this.clienteOriginal.telefone_comercial)) {
          atualizarInstancia = true
        }

        pedido.atualizar_instancia = atualizarInstancia

        deletarCamposParaSalvarCliente(pedido)
        await this.$http.post('/vendas', pedido)
          .then(res => {
            this.clienteOriginal = cloneDeep(pedido.cliente)
            this.$emit('input', { ...pedido, ...res.data })
            this.$emit('nextPage')
          })
          .catch(err => {
            if (err.response && err.response.data && err.response.data.Msg_Erro) {
              notification(AlertTypes.ERROR, err.response.data.Msg_Erro, 'Não foi possível salvar a venda')
            } else {
              notification(AlertTypes.ERROR, err, 'Não foi possível salvar a venda')
            }
          })
      },
      parseCliente (data, newConClienteMap) {
        let cliente = {}

        Object.keys(newConClienteMap).forEach(newConKey => {
          const rawValue = data[newConKey]
          const modelMap = newConClienteMap[newConKey]
          if (!isNil(modelMap.value(rawValue))) {
            set(cliente, modelMap.key, modelMap.value(rawValue))
          }
        })

        // Precisa limpar o model do cliente pra disparar o watch dentro dos componentes (Fisica e Juridica)
        // Porém não pode setar um objeto vazio {} por que ele perde os getters e setters do pessoa e para de
        // funcionar a computed is_fisica
        this.pedido.cliente = {
          pessoa: this.pedido.cliente.pessoa
        }
        Object.assign(this.pedido.cliente, cliente)
      }
    }
  }
</script>
<style scoped lang="scss">
    .tipo-pessoa-label {
        font-size: 16px;
        color: #adadad;
        font-weight: bold;
        margin: 9px 0;
    }

    .v-stepper, .v-stepper__header {
        box-shadow: none;
    }

    .v-stepper .v-stepper__content {
        padding: 0;
    }
</style>
